import { GetShiftsByEventCommandOutput, Shift } from '@amzn/red-velvet-api';
import { useAllPagesRedVelvetQuery } from '../allPagesRedVelvetQuery';

export function calculateShiftTime(shift: Shift | undefined) {
  if (!shift) return 0;

  const startDate = shift.startDateTime ? new Date(shift.startDateTime) : null;
  const endDate = shift.endDateTime ? new Date(shift.endDateTime) : null;
  if (startDate && endDate) {
    return (endDate.getTime() - startDate.getTime()) / (1000 * 60);
  }
  return 0;
}

export function useShiftTime(eventId: string, shiftId: string) {
  // We need the shift information to determine the default length of time for attendance
  const shiftsQuery = useAllPagesRedVelvetQuery({
    redVelvetQueryKey: ['getShiftsByEvent', { eventId }],
    converter: (output: GetShiftsByEventCommandOutput) => ({
      items: output.shifts || [],
      next: output.page,
    }),
  });

  const shift = (shiftsQuery.data || []).find((shift: Shift) => shift.shiftId === shiftId);
  return calculateShiftTime(shift);
}
